import { render, staticRenderFns } from "./tabke-photo.vue?vue&type=template&id=1fc95f39&scoped=true&"
import script from "./tabke-photo.vue?vue&type=script&lang=js&"
export * from "./tabke-photo.vue?vue&type=script&lang=js&"
import style0 from "./tabke-photo.vue?vue&type=style&index=0&id=1fc95f39&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc95f39",
  null
  
)

export default component.exports